import MarkdownIt from 'markdown-it';

const md = new MarkdownIt({
    breaks: true,
    html: false,
    linkify: true
});

export function useMarkdown() {
    const renderMessage = (content) => md.render(content);
    return { renderMessage };
}
